import AxiosForm from '../model/form/AxiosForm';
import { getOneClickCartList } from '../service/listner/cart';
import { yaTag } from '../middleware/yandex/yandex.tag';
import { onYaTag } from '../middleware/yandex/yandex.tag-data';

$(() => {
  const initFeaturedSlider = () => {
    $('.swiper-featured-products-tabs').each((_, container) => {
      const jContainer = $(container);
      const prev = $(jContainer).parent().find('.swiper-button-prev');
      const next = $(jContainer).parent().find('.swiper-button-next');
      const slides = container.querySelectorAll('.swiper-slide');

      const featuredProductsTabs = new Swiper(jContainer, {
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        preventClicks: false,
        preventClicksPropagation: false,
        keyboard: {
          enabled: true,
        },
        observer: true,
        observeParents: true,
        freeMode: true,
        freeModeMinimumVelocity: 0.02,
        autoHeight: true,
        grabCursor: true,
        slidesPerView: 'auto',
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        centeredSlides: false,
      });

      featuredProductsTabs.on('beforeTransitionStart', () => {
        swiperTabChange(container.closest('.container'));
      });

      featuredProductsTabs.on('sliderFirstMove', () => {
        (async function () {
          await yaTag(
            '$parent_CATEGORY_MOVE',
            null,
            container.closest('.container').dataset.yaContainer.slice(0, -1),
          );
        }());
      });

      featuredProductsTabs.on('click', () => {
        listenPreOrderButton();
        (async function () {
          await onYaTag();
        }());
      });

      const links = container.closest('.container').querySelectorAll('.nav-tabs-wrapper .nav-link');
      [...links].forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          tabChange($(e.currentTarget.getAttribute('href')), links);
          featuredProductsTabs
            .params.centeredSlides = (getSumSlideWith(slides) >= jContainer.width());
        });
      });
    });

    $('.swiper-featured-products').each((_, container) => {
      const jContainer = $(container);
      const slides = $(jContainer).find('.swiper-slide');
      const nextEl = $(jContainer).parent().find('.swiper-button-next');
      const prevEl = $(jContainer).parent().find('.swiper-button-prev');

      const featuredProducts = new Swiper(jContainer, {
        cssMode: true,
        slidesPerView: 2,
        loop: slides.length > 2,
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        breakpointsInverse: true,
        freeMode: true,
        autoHeight: true,
        grabCursor: true,
        breakpoints: {
          // when window width is >= 750px
          750: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            loop: slides.length > 3,
          },
        },
        navigation: {
          nextEl,
          prevEl,
        },
      });

      featuredProducts.on('slideChange', () => {
        listenPreOrderButton();
        listenBuyOneClick();
        featuredProducts.loopDestroy();
        featuredProducts.loopCreate();
      });

      featuredProducts.on('sliderFirstMove', () => {
        (async function () {
          await yaTag(
            '$parent_FEATURED_PRODUCTS_MOVE',
            null,
            container.closest('.container').dataset.yaContainer.slice(0, -1),
          );
        }());
      });

      featuredProducts.on('click', () => {
        (async function () {
          await yaTag(
            '$parent_FEATURED_PRODUCTS_CLICK',
            null,
            container.closest('.container').dataset.yaContainer.slice(0, -1),
          );
        }());
      });

      featuredProducts.on('beforeTransitionStart', () => {
        listenPreOrderButton();
        $('.swiper-slide').removeAttr('style');
        $('.swiper-container').removeAttr('style');
      });

      featuredProducts.on('slideChangeTransitionEnd', () => {
        listenPreOrderButton();
      });
    });
  };

  $('.swiper-recently-viewed').each((_, container) => {
    const jContainer = $(container);
    const slides = $(jContainer).find('.swiper-slide');
    const prev = $(jContainer).find('.swiper-recently-viewed-button-prev');
    const next = $(jContainer).find('.swiper-recently-viewed-button-next');

    const recentlyViewed = new Swiper(jContainer, {
      cssMode: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: slides.length > 1,
      observer: true,
      observeParents: true,
      breakpointsInverse: true,
      freeMode: true,
      autoHeight: true,
      grabCursor: true,
      breakpoints: {
        // when window width is >= 480px
        375: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          loop: slides.length > 2,
        },
        480: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          loop: slides.length > 3,
        },
        // when window width is >= 970px
        970: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          loop: slides.length > 4,
        },
      },

      navigation: {
        nextEl: next,
        prevEl: prev,
      },
    });

    if (window.windowSizeHelper.isTablet()) {
      $(recentlyViewed).find('.swiper-slide').removeAttr('style');
      $(recentlyViewed).removeAttr('style');
    }

    recentlyViewed.on('beforeTransitionStart', () => {
      $(recentlyViewed).find('.swiper-slide').removeAttr('style');
      $(recentlyViewed).removeAttr('style');
    });

    recentlyViewed.on('slideChange', () => {
      listenPreOrderButton();
      listenBuyOneClick();
      recentlyViewed.loopDestroy();
      recentlyViewed.loopCreate();
    });

    recentlyViewed.on('slideChangeTransitionEnd', () => {
      listenPreOrderButton();
    });

    recentlyViewed.on('sliderFirstMove', () => {
      (async function () {
        await yaTag(
          '$prefix_RELATED_MOVE',
          null,
          container.closest('.container').dataset.yaContainer,
        );
      }());
    });

    recentlyViewed.on('click', () => {
      (async function () {
        await yaTag(
          '$prefix_RELATED_CLICK',
          null,
          container.closest('.container').dataset.yaContainer,
        );
      }());
    });
  });

  initFeaturedSlider();
  window.initFeaturedSlider = initFeaturedSlider;
});

const swiperTabChange = (target) => {
  const tab = $(target.querySelector('.nav-tabs-wrapper .swiper-slide-active .nav-link')?.getAttribute('href'));
  const links = target.querySelectorAll('.nav-tabs-wrapper .nav-link');
  tabChange(tab, links);
  listenPreOrderButton();
};

function listenPreOrderButton() {
  const buttons = document.querySelectorAll('.btn-pre-order');
  Array.prototype.filter.call(buttons, (button) => {
    button.onclick = (e) => {
      const el = e.currentTarget.querySelector('button');
      const modal = document.querySelector(el.dataset.target);
      modal.querySelector('input#order-items-product-id').value = Number(el.dataset.productId);
    };
  });
}

function listenBuyOneClick() {
  if (document.querySelector('#productId') !== null) {
    const button = document.querySelector('.product-fast-order');
    const smCart = document.querySelector('.small-cart');
    const wrap = smCart.closest('.modal-typography-container');

    if (button !== null) {
      button.onclick = (e) => {
        const buttonBuy = e.currentTarget.closest('.form-row').querySelector('.event-add-to-cart');
        const isSold = (buttonBuy === null)
          ? true
          : buttonBuy.closest('.btn-buy').classList.contains('btn-sold');

        AxiosForm.showLoading(wrap, true);

        if (!isSold) {
          buttonBuy?.click();
          buttonBuy.closest('.btn-buy').addEventListener('Cart:add', () => {
            getOneClickCartList();
          });
        } else {
          getOneClickCartList();
        }
      };
    }
  }
}

function getSumSlideWith(slides) {
  let sum = 0;
  [...slides].forEach((slide) => {
    sum += slide.offsetWidth;
  });
  return sum;
}

const tabChange = (tab, links) => {
  tab.parent().find('.tab-pane')
    .hide()
    .removeClass('show');
  $(links).removeClass('active');
  $(`#${tab.attr('aria-labelledby')}`).addClass('active');
  tab.addClass('show');
  tab.addClass('active');
  tab.show();
};

window.tabChange = tabChange;
